/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-23 20:53:09
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/cell.js
 */
export default {
	// cell组件的props
	cell: {
		customClass: '',
		title: '',
		label: '',
		value: '',
		icon: '',
		disabled: false,
		border: true,
		center: false,
		url: '',
		linkType: 'navigateTo',
		clickable: false,
		isLink: false,
		required: false,
		arrowDirection: '',
		iconStyle: {},
		rightIconStyle: {},
		rightIcon: 'arrow-right',
		titleStyle: {},
		size: '',
		stop: true,
		name: ''
	}
}
